import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { RegularCollectionListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { exportCollectionPointFilteringSchemaObject } from '../exportCollectionPointSchema';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'REGULARCOLLECTIONPOINT'

export function RegularCollectionPointFiltering(props) {

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionPointCategory,setCollectionPointCategory]=useState([]);
    const [exportCollectionFilteringData, setExportCollectionFilteringData] = useState([]);
    const [errors, setErrors] = useState({});
    const schema = Joi.object(exportCollectionPointFilteringSchemaObject).options({ allowUnknown: true });

    const [exportCollectionFiltering, setExportCollectionFiltering] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionCategoryID: '0',
        collectionPointCategoryID:'0'
    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
        getPermissions();
        getCollectionPointCategoryForDropDown();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntityForDropDown()
        )
    }, [exportCollectionFiltering.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
    }, [exportCollectionFiltering.operationEntityID]);

    

    function handleGroupDropdown(target) {
        validateInputs(target);

        setExportCollectionFiltering({
            ...exportCollectionFiltering,
            groupID: target.value,
            operationEntityID: '0',
            collectionCategoryID: '0',
            collectionPointCategoryID:'0'
        });
    }

    function handleOperationEntityDropdown(target) {
        validateInputs(target);

        setExportCollectionFiltering({
            ...exportCollectionFiltering,
            operationEntityID: target.value,
            collectionCategoryID: '0',
            collectionPointCategoryID:'0'
        });
    }

    function handleCollectionPointDropdown(target) {
        validateInputs(target);

        setExportCollectionFiltering({
            ...exportCollectionFiltering,
            collectionCategoryID: target.value,
            collectionPointCategoryID:'0'
        });
    }

    function handleCollectionPointCategoryDropDown(target){
        setExportCollectionFiltering({
            ...exportCollectionFiltering,
            collectionPointCategoryID:target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, exportCollectionPointFilteringSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setExportCollectionFiltering({
            ...exportCollectionFiltering,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionCategoryID: '0',
        });
        setExportCollectionFilteringData([]);
        setErrors('');
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWREGULARCOLLECTIONPOINT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITREGULARCOLLECTIONPOINT');

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setExportCollectionFiltering({
            ...exportCollectionFiltering,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropdown(),
            getOperationEntityForDropDown()
        )
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntityForDropDown() {
        const operationEntity = await services.GetAllOperationEntityByGroupID(exportCollectionFiltering.groupID);
        setOperationEntity(operationEntity);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionPoint = await services.GetCollectionCategoryByOperationEntityID(exportCollectionFiltering.operationEntityID);
        setCollectionPoint(collectionPoint);
    }

    async function getCollectionPointCategoryForDropDown(){
        const collectionPointCategory=await services.getCollectionPointCategories();
        setCollectionPointCategory(collectionPointCategory);
    }

    async function handleSearch(e) {
        if (e !== undefined) {
            const errorMessages = validate(schema, exportCollectionFiltering);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;

        }

        const response = await services.getFilterExportCollection(exportCollectionFiltering);
        setExportCollectionFilteringData(response);
    }

    async function editCollectionFiltering(data) {
        props.history.push({
            pathname: 'regularCollectionPoint/addEdit',
            data: data,
            edit: true
        });

    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Collection Point Listing"
                                    isButtonEnable={true}
                                    path="regularCollectionPoint/addEdit"
                                    buttonText="Add Export CollectionPoint"
                                />
                            </div>
                            <hr />

                            <form disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={exportCollectionFiltering.groupID}
                                            onChange={(e) => handleGroupDropdown(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={exportCollectionFiltering.operationEntityID}
                                            onChange={(e) => handleOperationEntityDropdown(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCategoryID">Collection Category *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionCategoryID"
                                            id="collectionCategoryID"
                                            name="collectionCategoryID"
                                            value={exportCollectionFiltering.collectionCategoryID}
                                            onChange={(e) => handleCollectionPointDropdown(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Category--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionCategoryID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointCategoryID">CollectionPoint Category </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointCategoryID"
                                            id="collectionPointCategoryID"
                                            name="collectionPointCategoryID"
                                            value={exportCollectionFiltering.collectionPointCategoryID}
                                            onChange={(e) => handleCollectionPointCategoryDropDown(e.target)}
                                        >
                                            <MenuItem value="0">--Select CollectionPoint Category--</MenuItem>
                                            {generateDropDownMenu(collectionPointCategory)}
                                        </Select>
                                       
                                    </div>

                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                <RegularCollectionListing fieldFilteringData={exportCollectionFilteringData} handleClick={editCollectionFiltering} />

                            </form>

                        </div>
                    </div>
                </div>
            </div>

            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}